import { Hand, MousePointer2, Spline, StickyNote, type LucideIcon } from 'lucide-react';

export type Ferramenta = 'selecao' | 'mao' | 'nota' | 'conector';

const FERRAMENTAS: { ferramenta: Ferramenta; rotulo: string; Icone: LucideIcon }[] = [
  { ferramenta: 'selecao', rotulo: 'Selecionar (S)', Icone: MousePointer2 },
  { ferramenta: 'mao', rotulo: 'Mover o quadro (D ou Ctrl + arrastar)', Icone: Hand },
  { ferramenta: 'nota', rotulo: 'Post-it (N): clique no quadro', Icone: StickyNote },
  { ferramenta: 'conector', rotulo: 'Seta (C): clique na origem e no destino', Icone: Spline },
];

/** Ferramentas do quadro (RQ-QDR-004): seleção, mão, post-it e seta. */
export function BarraFerramentas({ ativa, definir }: { ativa: Ferramenta; definir: (f: Ferramenta) => void }) {
  return (
    <nav className="ferramentas" aria-label="Ferramentas do quadro">
      {FERRAMENTAS.map(({ ferramenta, rotulo, Icone }) => (
        <button key={ferramenta} type="button" aria-pressed={ativa === ferramenta} title={rotulo} aria-label={rotulo} onClick={() => definir(ferramenta)}>
          <Icone size={20} />
        </button>
      ))}
    </nav>
  );
}
